export const CHART_ACTIONS = {
  SET_CHART_INFO: "SET_CHART_INFO",
};
